import React from 'react'
import { shallow } from 'enzyme'

import Commmentary  from '../../features/Commentary/index'

describe('Commmentary', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      loan: {
        bankCommentaries: [
          {
            administrator: {
              rid: 123,
              name: 'SmartBiz Admin',
            },
            rid: 10,
            category: 'closing',
            content: 'testing content',
            state: 'published',
            replies: [
              {
                administrator: {
                  rid: 123,
                  name: 'SmartBiz Admin',
                },
                rid: 3,
                content: 'testing content',
              }
            ]
          }
      ]
      },
      loanId: 123,
      isBankUser: false,
    },
    wrapper = shallow(<Commmentary {...props} />)
    instance = wrapper.instance()
  })
  describe('#filterToCategory', () => {
    it('should return commentaries filtered based on the category function', () => {
      const category = props.loan.bankCommentaries[0].category
      const commentaries = instance.filterToCategory(category)
      expect(commentaries.length).toEqual(1)
      expect(commentaries[0].category).toEqual(category)
      expect(commentaries[0].category).toEqual('closing')
      expect(commentaries[0].replies.length).toEqual(1)
    })
  })
  describe('#getTitle', () => {
    it('should return title with uppercase', () => {
      expect(instance.getTitle('random_title')).toEqual('Random Title');
    })
  })
  describe('#getBankCommentry', () => {
    it('should return categories based on the commentary list', () => {
      const categories = instance.getBankCommentry(props.loan.bankCommentaries)
      expect(categories.length).toEqual(2)
      expect(categories[0].category).toEqual('underwriting');
      expect(categories[1].category).toEqual('closing');
      expect(categories[0].questions.length).toEqual(0);
      expect(categories[1].questions.length).toEqual(1);
    })
  })
  describe('#onSuccessNotify', () => {
    it('should call function', () => {
      const renderSuccessNotification = spyOn(instance, 'renderSuccessNotification')
      instance.onSuccessNotify()
      expect(wrapper.state('isSuccessNotificationVisible')).toBeTruthy();
      expect(renderSuccessNotification).toHaveBeenCalled()
    })
  })
  describe('#getDescription', () => {
    it('should return the description based on isBankUser props', () => {
      const description = "Respond to each request or question listed below. When you're ready for the bank to review your responses, click the Notify Bank button to alert them."
      expect(instance.getDescription()).toEqual(description)
    })
  })
})